<mat-card *ngIf="results.tabs.length>0">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'reports.exports.custom.shortLabel' | translate}}
                <app-tooltip text="{{'main.nav.links.reports.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content style="position: relative;">
        <section class="actions">
            <button mat-raised-button color="accent" class="export-btn" [disabled]="isExporting" (click)="onExportXLS()">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                    {{ 'reports.exports.xls.shortLabel' | translate }} </button>
            <button mat-raised-button color="accent" class="hidden" [disabled]="isExporting" (click)="onExportPPT()">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                    {{ 'reports.exports.ppt.shortLabel' | translate }} </button>
            <mat-spinner *ngIf="isExporting" [diameter]="35" color="accent"></mat-spinner>
        </section>
        <mat-tab-group *ngIf="!isExporting" animationDuration="0ms">
            <mat-tab *ngFor="let tab of results.tabs" label="{{tab.label}}">
                <div class="report-content">
                    <app-monitoring-results-graph *ngFor="let graph of tab.graphs"
                        [graph]="graph"></app-monitoring-results-graph>
                </div>
            </mat-tab>
            <mat-tab label="{{'monitoring.graphs.neverLogged.fullLabel' | translate}}">
                <div class="report-content">
                    <app-monitoring-results-users [users]="results.neverLoggedUsers"></app-monitoring-results-users>
                </div>
            </mat-tab>
        </mat-tab-group>
        <app-monitoring-results-print *ngIf="isExporting" [results]="results"></app-monitoring-results-print>
    </mat-card-content>
    <mat-card-content *ngIf="isExporting">
        <div class="print-mask">
            <h3>{{ 'reports.exportMessage.summary' | translate }}</h3>
            <mat-spinner [diameter]="35" color="accent" ></mat-spinner>
        </div>
    </mat-card-content>
</mat-card>
